<template>
  <div class="accountManagement">
    <!-- <div v-for="item,index in arrs" :key="index">
      <div style="display:flex" @click="xuanfaw(item)">
        <div v-if="item.parstatus">选中</div>
        <div v-else>未选中</div>
        <div style="margin-left:10px">{{ item.text }}</div>
      </div>

      <div v-for="items,indexr in item.children" :key="indexr" style="display:flex;padding-left:10px" @click="son(items,item)">
        <div v-if="items.status">选中</div>
        <div v-else>未选中</div>
        <div style="margin-left:10px">{{ items.text }}</div>
      </div>
    </div> -->
    <!-- 查询区内容 -->
    <div class="queryArea">
      <el-input v-model="parameter.title" placeholder="标题" class="queryArea_input" />
      <!-- <el-input v-model="parameter.novelTitle" placeholder="书名" class="queryArea_input" /> -->
      <el-select
        v-model="parameter.isOpen"
        class="launch"
        filterable
        placeholder="是否公开"
      >
        <el-option
          v-for="item in platforms"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left:10px"
        @click="serach"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="resetdaw"
      >重置</el-button>
      <el-button icon="el-icon-circle-plus" type="success" @click="addblish">新增子集</el-button>
    </div>

    <!-- 列表内容 -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      tooltip-effect="dark"
      style="width: 100%;margin-top:20px"
    >

      <el-table-column
        prop="typeText"
        label="类型"
        width="150"
        align="center"
      />
      <el-table-column
        prop="title"
        label="标题"
        width="250"
        align="center"
      />
      <!-- <el-table-column
        prop="bookName"
        label="书名"
        width="180"
        align="center"
      /> -->
      <el-table-column
        prop="platform"
        label="是否公开"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isOpen == 1 ? '不公开' :'公开' }}</span>
        </template>

      </el-table-column>
      <el-table-column
        prop="chapterGive"
        label="赠送标准(章节)"
        width="100"
        align="center"
      />
      <el-table-column
        prop="realName"
        label="创建人"
        width="150"
        align="center"
      />
      <el-table-column
        prop="createdAtText"
        label="创建时间"
        width="180"
        align="center"
      />
      <el-table-column
        label="封面图片"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img style="width:50px;height:50px" :src="scope.row.coverPicturePath" alt="">
        </template>
      </el-table-column>
      <el-table-column
        label="底部图片"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <img style="width:50px;height:50px" :src="scope.row.bottomPicturePath" alt="">
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editr(scope.row)">编辑</el-button>
          <el-button type="primary" size="mini" @click="deleteallr(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="新增子集"
      :visible.sync="dialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <addsubsetdialog ref="addsundiolig" @closer="closer" />
    </el-dialog>

  </div>
</template>

<script>
import addsubsetdialog from './components/addsubsetdialog.vue'
import { atlasinfolist, atlasdelete } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    addsubsetdialog,
    PaginationRight
  },
  data() {
    return {
      arrs: [
        {
          id: 1,
          parstatus: false,
          text: '父1',
          children: [
            {
              id: 2,
              text: '子1',
              status: false
            },
            {
              id: 3,
              text: '子2',
              status: false
            }
          ]
        },
        {
          id: 1,
          parstatus: false,
          text: '父2',
          children: [
            {
              id: 2,
              text: '子3',
              status: false
            },
            {
              id: 3,
              text: '子4',
              status: false
            }
          ]
        }
      ],
      parameter: {
        page: 1,
        pageSize: 10,
        atlasId: this.$route.query.id,
        title: null,
        novelTitle: null,
        isOpen: ''
      },
      platforms: [
        {
          name: '全部',
          id: ''
        }, {
          name: '不公开',
          id: 1
        },
        {
          name: '公开',
          id: 2
        }], // 平台数据
      tableData: [], // 列表数据
      dialogVisible: false, // 新增排行榜弹窗
      total: null// 总页数

    }
  },
  watch: {

  },
  async created() {
    console.log('参数', this.$route.query)
    this.subsetliset()
  },
  mounted() {

  },
  methods: {
    xuanfaw(item) {
      console.log('item', item)
      // eslint-disable-next-line eqeqeq
      if (item.parstatus == true) {
        item.parstatus = false
        item.children.forEach(element => {
          element.status = false
        })
      } else {
        item.parstatus = true
        item.children.forEach(element => {
          element.status = true
        })
      }
    },
    son(son, father) {
      console.log('子', son)
      console.log('父', father)
      son.status = !son.status
      const flag = father.children.every(function(a) {
        // eslint-disable-next-line eqeqeq
        return a.status == true
      })
      if (flag) {
        father.parstatus = true
      } else {
        father.parstatus = false
      }
    },
    // 子集列表
    async subsetliset() {
      const data = await atlasinfolist(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data图集子集', data)
    },
    // 分页
    fetchPageSize(e) {
      this.parameter.pageSize = e
      this.getweatlas()
    },
    fetchCurrentPage(e) {
      this.parameter.page = e
      this.getweatlas()
    },
    addblish() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addsundiolig.send(1, this.$route.query)
      })
    },
    editr(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addsundiolig.send(2, this.$route.query, item)
      })
    },
    deleteallr(id) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        atlasdelete({
          id: id
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.subsetliset()
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    closer() {
      this.dialogVisible = false
      this.subsetliset()
    },
    serach() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.subsetliset()
    },
    resetdaw() {
      this.parameter.page = 1
      this.parameter.pageSize = 10
      this.parameter.title = null
      this.parameter.novelTitle = null
      this.parameter.isOpen = ''
      this.subsetliset()
    }
  }
}
</script>
<style scoped>
.accountManagement{
   padding: 30px 60px;
}

.queryArea_input{
  width: 150px;
  margin-right: 10px;
}

</style>
